import axios from 'axios'

const isProduction = true
const http = isProduction ? "https://palau-macaya-sjdfb.ondigitalocean.app/la-llucana-webinar-backend/api" : "https://la-llucana-preproduction-exv7o.ondigitalocean.app/api"; //10.242.124.186  //127.0.0.1
const apiService = {
    createUser(data: object) {
        return axios.post(`${http}/createUser`, data)
    },
    deleteUser(data: object, accessToken: string) {
        return axios.post(`${http}/deleteUser`, data, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }

        })
    },
    verifyPromotionalCode(code: object, accessToken: string) {
        return axios.post(http + '/verifyEvent', code, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    verifyCredentials(credentials: object, accessToken: string) {
        return axios.post(`${http}/verifyCredentials`, credentials, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    getEvents(accessToken: string, data: object) {
        return axios.post(`${http}/getEvents`, data, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },

    createEvent(accessToken: string, data: object) {
        return axios.post(`${http}/createEvent`, data, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    modifyEvent(accessToken: string, data: object) {
        return axios.post(`${http}/modifyEvent`, data, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    getQuestions(accessToken: string, code: string, email: string) {
        return axios.get(`${http}/getQuestions?code=${code}&&email=${email}`, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    deleteEvent(accessToken: string, data: object) {
        return axios.post(`${http}/deleteEvent`, data, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    logOutUser(accessToken: string, data: object) {
        return axios.post(`${http}/logOutUser`, data, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    getCompanies(accessToken: string) {
        return axios.get(`${http}/getCompanies`, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    getUsers(accessToken: string) {
        return axios.get(`${http}/getUsers`, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    deleteUserWithEmail(accessToken: string, data: object) {
        return axios.post(`${http}/deleteUserWithEmail`, data, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    registerNewUser(accessToken: string, data: object) {
        return axios.post(`${http}/registerNewUser`, data, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    },
    resetPassword(data: object) {
        return axios.post(`${http}/resetPassword`, data)
    },
    sendNewPassword(data: object) {
        return axios.post(`${http}/sendNewPassword`, data)
    },
    generateId () {
        return '_' + Math.random().toString(36).substr(2, 9);
    }
}
export default apiService
